import { render, staticRenderFns } from "./ViewCertificate.vue?vue&type=template&id=81ec7430&"
import script from "./ViewCertificate.vue?vue&type=script&lang=js&"
export * from "./ViewCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports